import styles from './styles/FirstLevelTabs.module.scss';

type FirstLevelTabsProps = {
  tabs: Array<{ key: string; title: string }>;
  activeTabKey: string;
  tabClick: (key: string) => void;
};

const FirstLevelTabs = ({ tabs, activeTabKey, tabClick: tabCLick }: FirstLevelTabsProps) => (
  <section className={`${styles['first-level-tabs']} background-island overflow-auto`}>
    <div className="container">
      <div className="d-flex gap-3">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`text-nowrap ${tab.key === activeTabKey ? styles.active : ''}`}
            onClick={() => tabCLick(tab.key)}
          >
            {tab.title}
          </button>
        ))}
      </div>
    </div>
  </section>
);

export default FirstLevelTabs;
